import {
  IconActionHistory,
  IconCatalog,
  IconCheck,
  IconWarning,
} from '@procurify/ui'

import {
  type CatalogItemTagIcon,
  CatalogItemTagIcons,
} from '../../value-objects/CatalogItemTag'

const GLYPH_SCALES: Record<CatalogItemTagIcon, number> = {
  [CatalogItemTagIcons.WARNING]: 1,
  [CatalogItemTagIcons.CHECKMARK]: 11 / 16,
  [CatalogItemTagIcons.CATALOG]: 12 / 16,
  [CatalogItemTagIcons.PREVIOUS_ORDER]: 12 / 16,
}

export interface ICatalogItemTagGlyphProps {
  icon: CatalogItemTagIcon
  size: number
}

export const CatalogItemTagGlyph = ({
  icon,
  size,
}: ICatalogItemTagGlyphProps) => {
  const glyphSize = Math.round(size * (GLYPH_SCALES[icon] ?? 1))

  switch (icon) {
    case CatalogItemTagIcons.WARNING:
      return <IconWarning size={glyphSize} />
    case CatalogItemTagIcons.CATALOG:
      return <IconCatalog size={glyphSize} />
    case CatalogItemTagIcons.PREVIOUS_ORDER:
      return <IconActionHistory size={glyphSize} />
    case CatalogItemTagIcons.CHECKMARK:
      return <IconCheck size={glyphSize} />
    default:
      return null
  }
}
